import * as React from 'react';
import { IUIUrval } from '../../../../../../../Types/UrvalTypes';
import { StandardColumnType } from '../SideMenu/Components/PeriodOchKolumner/EditColumn/Components/Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import { IEkonomiskAnalysDates } from '../AnalysSettingsHandler/AnalysSettingsHandler';
import { IUserInfo } from '../../Utils/ekonomiskAnalysInitQueryUtils';

export interface IAnalysResultColumn {
  name: string;
  index: number;
  fieldCode: string;
}

interface IEkonomiskAnalysContext {
  accessibilityMode: boolean;
  // Also includes bokföringsperiodcolumns vid rullande 12
  analysResultColumns: IAnalysResultColumn[];
  codeSystemId: string;
  columnSelectOpen: boolean;
  dbName: string;
  grundurvalUrval?: IUIUrval;
  harPeriodiseradBudget: boolean;
  hasWholeCodeBook: boolean;
  kodbehorighetsUrval?: IUIUrval;
  isChanges: boolean;
  leftSidebarOpen: boolean;
  radBaserad: boolean;
  setAnalysResultColumns: (columns: IAnalysResultColumn[]) => void;
  setStartDates: (newStartDates: IEkonomiskAnalysDates) => void;
  setUrval: (urval: IUIUrval) => void;
  setUseZeroSums: (updated: boolean) => void;
  standardColumns: StandardColumnType[] | undefined;
  updateReport: (updateOrig?: boolean) => void;
  urval: IUIUrval | null;
  userInfo?: IUserInfo;
  useZeroSums: { org: boolean; updated: boolean };
}

export const EkonomiskAnalysContext =
  React.createContext<IEkonomiskAnalysContext>({
    accessibilityMode: false,
    analysResultColumns: [],
    codeSystemId: '',
    columnSelectOpen: false,
    dbName: '',
    harPeriodiseradBudget: false,
    hasWholeCodeBook: false,
    isChanges: false,
    leftSidebarOpen: true,
    radBaserad: false,
    setAnalysResultColumns: () => {},
    setStartDates: () => {},
    setUrval: () => {},
    setUseZeroSums: () => {},
    standardColumns: undefined,
    updateReport: () => {},
    urval: null,
    userInfo: undefined,
    useZeroSums: { org: true, updated: false },
  });

export const EkonomiskAnalysContextProvider = EkonomiskAnalysContext.Provider;
export const EkonomiskAnalysContextConsumer = EkonomiskAnalysContext.Consumer;
